import * as yup from "yup";

const SegmentFormValidationSchema = yup.object().shape({
  name: yup
    .string()
    .required("Segment name is required")
    .min(2, "Name must be at least 2 characters")
    .max(100, "Name cannot exceed 100 characters"),
  description: yup
    .string()
    .required("Description is required")
    .max(500, "Description cannot exceed 500 characters"),
  rules: yup
    .array()
    .of(
      yup.object().shape({
        field: yup.string().required("Field is required"),
        operator: yup.string().required("Rule is required"),
        value: yup.mixed().required("Value is required"),
      })
    )
    .min(1, "At least one rule is required"),
  logic_operator: yup
    .string()
    .oneOf(["AND", "OR"])
    .required("Logic operator is required"),
  is_active: yup.boolean(),
});

export default SegmentFormValidationSchema;
